import { INDENT_SIZE, MAX_INDENT_LEVEL } from "./indent.command";

export const indentBlocks = ({ blocks }) => {
  blocks.forEach((block) => {
    const currentPadding = parseInt(
      window.getComputedStyle(block).paddingLeft || "0",
    );
    const currentLevel = Math.floor(currentPadding / INDENT_SIZE);

    // Check if already at max indent level
    if (currentLevel >= MAX_INDENT_LEVEL) {
      console.warn(`Max indent level (${MAX_INDENT_LEVEL}) reached`);
      return;
    }

    block.style.paddingLeft = `${currentPadding + INDENT_SIZE}px`;
  });
};

export const indentList = ({ blocks }) => {
  if (!blocks || blocks.length === 0) {
    return;
  }

  // Group consecutive li elements that share the same parent
  const groups = [];
  let currentGroup = [];
  let lastParent = null;

  blocks.forEach((li) => {
    const parent = li.parentNode;

    if (parent === lastParent && currentGroup.length > 0) {
      // Same parent, add to current group
      currentGroup.push(li);
    } else {
      // Different parent or first item, start new group
      if (currentGroup.length > 0) {
        groups.push(currentGroup);
      }
      currentGroup = [li];
      lastParent = parent;
    }
  });

  // Don't forget the last group
  if (currentGroup.length > 0) {
    groups.push(currentGroup);
  }

  // Process each group
  groups.forEach((group) => {
    if (group.length === 0) return;

    const firstLi = group[0];
    const tagName = firstLi.parentNode?.nodeName.toLowerCase() || null;
    if (!tagName) return;

    const parentList = firstLi.parentNode;
    if (!parentList) return;

    // Check indent level - count nested ul/ol parents
    let level = 0;
    let current = firstLi.parentElement;
    while (current) {
      const tag = current.tagName.toLowerCase();
      if (tag === "ul" || tag === "ol") {
        level++;
      }
      current = current.parentElement;
    }

    // Max indent level is 15
    if (level >= 15) {
      console.warn("Max indent level (15) reached");
      return;
    }

    // Create ONE nested list for the entire group
    const nestedList = document.createElement(tagName);

    // Insert nested list at the position of first li
    parentList.insertBefore(nestedList, firstLi);

    // Move all li elements in the group into the nested list
    group.forEach((li) => {
      nestedList.appendChild(li);
    });
  });
};
